import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import { default as Header } from "../../Components/Header2/Header2";
import "./IGMgmtDashboard.css";

const sections = [
  {
    key: "user-activity",
    label: "User Activity",
    path: "/user-management/UserActivity",
    icon: "👥",
    description: "View all user activities and tracking."
  },
  {
    key: "contract-status",
    label: "Contract Status",
    path: "/user-management/ContractStatus",
    icon: "📝",
    description: "View All user contract statuses."
  },
  {
    key: "role-admin-dashboard",
    label: "Role Admin Dashboard",
    path: "/user-admin",
    icon: "🔐",
    description: "Modify and Assign roles and permissions for users."
  },
  {
    key: "user-management",
    label: "User Management",
    path: "/user-management",
    icon: "🔨",
    description: "Create, edit, and delete users."
  },
  {
    key: "contracts-admin",
    label: "Contracts Admin",
    path: "/contracts-admin",
    icon: "✏️",
    description: "view status and approve or deny contracts."
  },
  {
    key: "reports",
    label: "Reports",
    path: "/reports",
    icon: "📈",
    description: "View different reports."
  }
];

export const IGMgmtDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='generalPage'>
      <Header />
      <div className="roleadmin-container">
        <div className='pageContainer'>

          <div className="button-container">
            <button
              className="back-button"
              onClick={() => navigate('/')}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
            </button>
          </div>

          <h1 className="user-admin-title">Role Admin Dashboard</h1>
          <div className="dashboard-subtitle">Manage Roles and Permissions</div>
          <div className="pills-container">
            {sections.map((section) => (
              <div key={section.key} className="pill-box">
                <div className="pill-icon">{section.icon}</div>
                <h2 className="pill-title">{section.label}</h2>
                <p className="pill-description">{section.description}</p>
                <Link to={section.path} className="pill-link">
                  Go to {section.label}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IGMgmtDashboard;
